module.exports = __webpack_public_path__ + "static/media/close-circle.0e945f00.svg";